import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SplashPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/language');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 flex items-center justify-center">
      <div className="text-center">
        <div className="mb-8">
          <div className="w-32 h-32 mx-auto bg-white rounded-full flex items-center justify-center shadow-2xl">
            <span className="text-4xl font-bold text-blue-600" style={{ fontFamily: 'Pacifico, serif' }}>
              فَنَار
            </span>
          </div>
        </div>
        
        <h1 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
          Fanar App
        </h1>
        
        <p className="text-blue-100 text-lg mb-8">
          تجربة حجز شاملة ومتكاملة
        </p>
        
        <div className="flex justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashPage;